import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

import {pxToRem} from '../../utils';

const StyledShowTotalDiv = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'baseline',
  backgroundColor: theme.palette.white,
  padding: pxToRem(8),
  borderRadius: pxToRem(8),
  marginRight: pxToRem(8),
}));
const StyledShowTotalTypography = styled(Typography)(({theme, textcolor}) => ({
  color: textcolor,
  fontWeight: 800,
}));

const Legend = ({label, data, textColor}) => {
  return (
    <StyledShowTotalDiv>
      <StyledShowTotalTypography textcolor={textColor}>
        {label} {data}
      </StyledShowTotalTypography>
    </StyledShowTotalDiv>
  );
};

export default Legend;
